import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../models/http-model';
import { HttpClient } from '@angular/common/http';
import { HttpSoap } from '../http-soap.service';

/*import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/Rx';*/
import { SoapRequestService } from '../../../shared/services/soap/soap-request.service';

const HEADERS = {};
@Injectable()
export class ExtractionService {
  static ENV = environment;

  constructor
  (
    private httpProvider: HttpService,
    private http: HttpClient,
    private soap: HttpSoap,
    private soapRequestService: SoapRequestService
  ) {}

}



// WEBPACK FOOTER //
// ./src/app/core/services/extraction/extraction.service.ts